import { ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { forwardRef } from 'react'
import { ScrollView } from 'react-native'
import { useStores } from '../../data/store'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'

const listViewWithoutSearch = forwardRef(({ children, ...props }: any, ref: any) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))
  const { type } = props

  const title =
    type === PAYMENT_MODE_SUBTYPES.NB || type === PAYMENT_MODE_SUBTYPES.CORP_NB ? 'All Banks' : 'All Wallets'

  const style = styles(theme)
  return (
    <ScrollView
      {...props}
      ref={ref}
      scrollEventThrottle={10}
      onScroll={(e) => {
        props.onScroll(e)
      }}
      contentContainerStyle={{
        flex: 1,
      }}>
      <Text {...style.mobileHeaderTitle}>{title}</Text>
      <Spacer direction="vertical" size={16} />
      {children}
    </ScrollView>
  )
})

const styles = (theme: any) => ({
  mobileHeaderTitle: {
    color: theme?.brandColor as ColorOptions,
    fontSize: 14,
    fontFamily: 'jioType-medium',
  } as TextProps,
})

export { listViewWithoutSearch }
